import algoliasearch from "algoliasearch";
import { APPLICATION_ID, API_KEY } from "../constants";

export const algoliaClient = algoliasearch(APPLICATION_ID, API_KEY);
